import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as StaffActions from './staff.actions';
import { OrgStaffUserInterfaceWithId } from '@sk/sk-interfaces';


export const STAFF_FEATURE_KEY = 'staff';

export interface StaffState extends EntityState<OrgStaffUserInterfaceWithId> {
  selectStaffId: string | null; // which Clients record has been selected
  staffLoaded: boolean; // has the Clients list been loaded
  staffLoadError?: string | null; // last none error (if any)
  queryStaffLoadError?: string | null; // last none error (if any)

  addStaffError?: string | null; // last none error when adding a new client (if any)
  addStaffSuccess: boolean; // last none error when adding a new client (if any)

  updateStaffError?: string | null; // last none error when adding a new client (if any)
  updateStaffSuccess: boolean; // last none error when adding a new client (if any)


  deleteStaffError?: string | null; // last none error when adding a new client (if any)
  deleteStaffLoaded: boolean; // last none error when adding a new client (if any)
}

export interface StaffPartialState {
  readonly [STAFF_FEATURE_KEY]: StaffState;
}

export const staffAdapter: EntityAdapter<OrgStaffUserInterfaceWithId> = createEntityAdapter<OrgStaffUserInterfaceWithId>({
  selectId: selectStaffId
});

export const initialState: StaffState = staffAdapter.getInitialState({
  // set initial required properties
  selectStaffId: null,
  staffLoaded: false,
  addStaffSuccess: false,
  updateStaffSuccess: false,
  deleteStaffLoaded: false
});


export function selectStaffId(a: OrgStaffUserInterfaceWithId): string {
  //In this case this would be optional since primary key is id
  return a.id;
}


const staffReducer = createReducer(
  initialState,

  on(StaffActions.loadStaff, (state) => {
    if (state.staffLoadError) {
      delete state.staffLoadError;
    }
    if (state.addStaffError) {
      delete state.addStaffError;
    }
    if (state.updateStaffError) {
      delete state.updateStaffError;
    }
    if (state.deleteStaffError) {
      delete state.deleteStaffError;
    }

    return ({
      ...state,
      staffLoaded: false
    });
  }),

  on(StaffActions.loadStaffsSuccess, (state, { staff }) => {
    return {
      ...state,
      staffLoaded: true
    };
  }),

  on(StaffActions.loadStaffsFailure, (state, { error }) => {
    if (error) {
      console.error(error);
    }
    return ({
      ...state,
      staffLoadError: error
    });
  }),

  // ACTIONS INITIATED FROM THIS CLIENT
  // FIREBASE WILL AUTOMATICALLY UPDATE STATE THROUGH QUERY!!


  /**
   * Add Staff from Client
   */
  on(StaffActions.addStaff, (state, { staff }) => {
    if (state.addStaffError) {
      delete state.addStaffError;
    }
    return ({
      ...state,
      addStaffSuccess: false
    });
  }),

  on(StaffActions.addStaffError, (state, { error }) => {
    return ({
      ...state,
      addStaffError: error.message
    });
  }),

  on(StaffActions.addStaffSuccess, (state, {}) => {
    if (state.addStaffError) {
      delete state.addStaffError;
    }
    return ({
      ...state,
      addStaffSuccess: true
    });
  }),

  /**
   * Delete Staff from Client
   */
  on(StaffActions.removeStaff, (state, {
    id
  }) => {
    if (state.deleteStaffError) {
      delete state.deleteStaffError;
    }
    return staffAdapter.removeOne(id, {
      ...state,
      deleteStaffLoaded: false
    });
  }),


  on(StaffActions.removeStaffSuccess, (state, {}) => {
    if (state.deleteStaffError) {
      delete state.deleteStaffError;
    }
    return ({
      ...state,
      deleteStaffLoaded: true
    });
  }),


  on(StaffActions.removeStaffError, (state, {
    error
  }) => {
    return ({
      ...state,
      deleteStaffError: error.message
    });

  }),


  /**
   * Update staff from Client
   */
  on(StaffActions.updateStaff, (state, { id, changes }) => {
    if (state.updateStaffError) {
      delete state.updateStaffError;
    }
    return staffAdapter.updateOne({
        id,
        changes
      },
      {
        ...state,
        updateStaffSuccess : false
      });
  }),

  on(StaffActions.updateStaffSuccess, (state, {}) => {
    if (state.updateStaffError) {
      delete state.updateStaffError;
    }
    return {
      ...state,
      updateStaffSuccess: true
    };
  }),

  on(StaffActions.updateStaffError, (state, { error }) => {
    return ({
      ...state,
      updateStaffError: error.message
    });
  }),


  /**
   * FIRSTORE ACTIONS
   */
  on(StaffActions.fromFireStoreAddStaff, (state, { staff }) => {
    if (state.queryStaffLoadError) {
      delete state.queryStaffLoadError;
    }
    return staffAdapter.setOne(staff, state);
  }),

  on(StaffActions.fromFireStoreModifyStaff, (state, { staff }) => {
    if (state.queryStaffLoadError) {
      delete state.queryStaffLoadError;
    }
    return staffAdapter.updateOne({
        id: staff.id,
        changes: staff
      },
      state);
  }),
  on(StaffActions.fromFireStoreRemoveStaff, (state, {
    id
  }) => {
    if (state.queryStaffLoadError) {
      delete state.queryStaffLoadError;
    }
    return staffAdapter.removeOne(id, state);
  }),
  on(StaffActions.queryFireStoreStaffError, (state, {
    error
  }) => {
    return {
      queryStaffLoadError: error.message,
      ...state
    };

  })
);


export function reducer(state: StaffState | undefined, action: Action) {
  return staffReducer(state, action);
}
